'use client';
var ACCORDION_ERRORS = {
    context: "Компонент Accordion не найден в дереве",
    itemContext: "Компонент Accordion.Item не найден в дереве",
    value: "Компонент Accordion.Item был отрендерен с невалидным или неуказанным value"
};

export { ACCORDION_ERRORS };
